import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { selectFeedFilters } from 'redux/slices/feedSlice';
import { FeedFilter, feedFilterStrings } from 'redux/types/feedTypes';
import { FilterChips } from '@act/storybook';

const FeedFilters = () => {
  const [selectedFilters, setSelectedFilters] = useState<FeedFilter[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    void dispatch(selectFeedFilters(selectedFilters));
  }, [selectedFilters, dispatch]);

  return (
    <FilterChips
      filterChoices={feedFilterStrings.map(s => ({ label: s, value: s }))}
      setSelectedFilters={setSelectedFilters}
    />
  );
};

export default FeedFilters;
